// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset */
* {
  box-sizing: border-box;
}

/* Layout */
.app-layout {
  min-height: 100vh;
  background-color: #f4f6f8;
  font-family: Arial, sans-serif;
}

/* Header */
.app-header {
  height: 56px;
  background-color: #111827;
  color: #ffffff;
  display: flex;
  align-items: center;
  padding: 0 20px;
  font-size: 18px;
  font-weight: bold;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
}

/* Sidebar */
.app-sidebar {
  position: fixed;
  top: 56px;
  left: 0;
  width: 220px;
  height: calc(100vh - 56px);
  background-color: #1f2937;
  padding: 16px;
  color: #ffffff;
}

.sidebar-title {
  font-size: 14px;
  text-transform: uppercase;
  margin-bottom: 12px;
  color: #9ca3af;
}

.sidebar-item {
  padding: 10px 12px;
  border-radius: 6px;
  cursor: pointer;
  margin-bottom: 6px;
}

.sidebar-item:hover {
  background-color: #374151;
}

/* Content */
.app-content {
  margin-top: 56px;
  margin-left: 220px;
  padding: 20px;
}

/* Dashboard */
.dashboard-header {
  /* font-size: 24px;
  font-weight: bold; */
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dashboard-header-link{
  padding: 10px 15px;
  color: #ffffff;
  background-color: #374151;
  border-radius: 5px;
  text-decoration: none;
  border: none;
  margin: 0px 5px;
  cursor: pointer;
}

.action-link{
  background-color: #ffffff;
  text-decoration: underline;
  border: none;
  font-size: 16px;
  cursor: pointer;
}

/* Cards */
.dashboard-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.dashboard-card {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.dashboard-card-title {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 8px;
}

.dashboard-card-value {
  font-size: 22px;
  font-weight: bold;
}

/* Section */
.dashboard-section {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.dashboard-section-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 12px;
}

/* Table */
.dashboard-table {
  width: 100%;
  border-collapse: collapse;
}

.dashboard-table th {
  text-align: left;
  padding: 8px;
  border-bottom: 1px solid #e5e7eb;
  color: #6b7280;
  font-size: 14px;
}

.dashboard-table td {
  padding: 8px;
  border-bottom: 1px solid #e5e7eb;
}

.dashboard-table tbody tr:hover {
  background-color: #f9fafb;
}

.btn{
  background-color: #374151;
  border: none;
  padding: 10px 15px;
  color: #ffffff;
  border-radius: 5px;
  margin: 10px 5px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Report/style.css"],"names":[],"mappings":"AAAA,UAAU;AACV;EACE,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA,WAAW;AACX;EACE,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,YAAY;EACZ,0BAA0B;EAC1B,yBAAyB;EACzB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA,cAAc;AACd;EACE;sBACoB;EACpB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;EAChC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":["/* Reset */\n* {\n  box-sizing: border-box;\n}\n\n/* Layout */\n.app-layout {\n  min-height: 100vh;\n  background-color: #f4f6f8;\n  font-family: Arial, sans-serif;\n}\n\n/* Header */\n.app-header {\n  height: 56px;\n  background-color: #111827;\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  padding: 0 20px;\n  font-size: 18px;\n  font-weight: bold;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 100;\n}\n\n/* Sidebar */\n.app-sidebar {\n  position: fixed;\n  top: 56px;\n  left: 0;\n  width: 220px;\n  height: calc(100vh - 56px);\n  background-color: #1f2937;\n  padding: 16px;\n  color: #ffffff;\n}\n\n.sidebar-title {\n  font-size: 14px;\n  text-transform: uppercase;\n  margin-bottom: 12px;\n  color: #9ca3af;\n}\n\n.sidebar-item {\n  padding: 10px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  margin-bottom: 6px;\n}\n\n.sidebar-item:hover {\n  background-color: #374151;\n}\n\n/* Content */\n.app-content {\n  margin-top: 56px;\n  margin-left: 220px;\n  padding: 20px;\n}\n\n/* Dashboard */\n.dashboard-header {\n  /* font-size: 24px;\n  font-weight: bold; */\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.dashboard-header-link{\n  padding: 10px 15px;\n  color: #ffffff;\n  background-color: #374151;\n  border-radius: 5px;\n  text-decoration: none;\n  border: none;\n  margin: 0px 5px;\n  cursor: pointer;\n}\n\n.action-link{\n  background-color: #ffffff;\n  text-decoration: underline;\n  border: none;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n/* Cards */\n.dashboard-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.dashboard-card {\n  background-color: #ffffff;\n  border-radius: 8px;\n  padding: 16px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n}\n\n.dashboard-card-title {\n  font-size: 14px;\n  color: #6b7280;\n  margin-bottom: 8px;\n}\n\n.dashboard-card-value {\n  font-size: 22px;\n  font-weight: bold;\n}\n\n/* Section */\n.dashboard-section {\n  background-color: #ffffff;\n  border-radius: 8px;\n  padding: 16px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n}\n\n.dashboard-section-title {\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 12px;\n}\n\n/* Table */\n.dashboard-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.dashboard-table th {\n  text-align: left;\n  padding: 8px;\n  border-bottom: 1px solid #e5e7eb;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n.dashboard-table td {\n  padding: 8px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.dashboard-table tbody tr:hover {\n  background-color: #f9fafb;\n}\n\n.btn{\n  background-color: #374151;\n  border: none;\n  padding: 10px 15px;\n  color: #ffffff;\n  border-radius: 5px;\n  margin: 10px 5px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
